import { QUERY_KEYS } from 'api/query-keys';
import { useQuery } from 'react-query';
import { sharedWorkflowService } from 'api/services';
import { Site } from 'shared/hooks/use-site-detection.types';
import { WorkflowDetailsResponseDto } from 'api/services/workflow/workflow-service.types';

export const useGetWorkflowDetails = (site: Site, workflowId: string) => {
  const queryFn = async () => await sharedWorkflowService.getWorkflowDetails(site, workflowId);

  return useQuery<WorkflowDetailsResponseDto, Error>(
    QUERY_KEYS.workflowDetails(workflowId),
    queryFn,
    {
      enabled: !!workflowId,
    }
  );
};
